import request from './request'

export function listSupplySuggestion(data) {
  return request.post('/production/supply-suggestions/list', data)
}
export function getSupplySuggestion(id) {
  return request.get('/production/supply-suggestions/' + id)
}
export function generateSupplySuggestion(data) {
  return request.post('/production/supply-suggestions/generate-from-coverage', data)
}
export function generateSupplySuggestionFromRequirement(requirementId) {
  return request.post('/production/supply-suggestions/generate-from-requirement', { requirementId })
}
export function generateSupplySuggestionFromMinStock() {
  return request.post('/production/supply-suggestions/generate-from-min-stock', {})
}
export function confirmSupplySuggestion(suggestionId) {
  return request.post('/production/supply-suggestions/confirm', { suggestionId })
}
export function unconfirmSupplySuggestion(suggestionId) {
  return request.post('/production/supply-suggestions/unconfirm', { suggestionId })
}
export function deleteSupplySuggestion(ids) {
  return request.post('/production/supply-suggestions/delete', ids)
}
